const THAI_MONTHS = [
  'มกราคม',
  'กุมภาพันธ์',
  'มีนาคม',
  'เมษายน',
  'พฤษภาคม',
  'มิถุนายน',
  'กรกฎาคม',
  'สิงหาคม',
  'กันยายน',
  'ตุลาคม',
  'พฤศจิกายน',
  'ธันวาคม',
]

const ENGLISH_MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

/**
 * Format a number as Thai Baht currency.
 * Example: 32000 -> "฿ 32,000.00"
 */
export function formatCurrency(amount: number | null | undefined): string {
  if (amount == null || isNaN(amount)) return '฿ 0.00'
  const formatted = amount.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
  return `฿ ${formatted}`
}

/**
 * Format a number with comma separators.
 * Example: 1234567 -> "1,234,567"
 */
export function formatNumber(n: number | null | undefined): string {
  if (n == null || isNaN(n)) return '0'
  return n.toLocaleString('en-US')
}

/**
 * Format an ISO date string to DD/MM/YYYY (Thai convention).
 * Example: "2026-03-31" -> "31/03/2026"
 */
export function formatDate(dateStr: string): string {
  const date = new Date(dateStr)
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const year = date.getFullYear()
  return `${day}/${month}/${year}`
}

/**
 * Format an ISO date string to long Thai format.
 * Example: "2026-03-31" -> "31 มีนาคม 2026"
 */
export function formatDateLong(dateStr: string): string {
  const date = new Date(dateStr)
  const day = date.getDate()
  const monthName = THAI_MONTHS[date.getMonth()]
  const year = date.getFullYear()
  return `${day} ${monthName} ${year}`
}

/**
 * Get the Thai month name for a 1-based month number.
 * Example: 3 -> "มีนาคม"
 */
export function formatMonth(month: number): string {
  return THAI_MONTHS[month - 1] || ''
}

/**
 * Get the English month name for a 1-based month number.
 * Example: 3 -> "March"
 */
export function formatMonthEn(month: number): string {
  return ENGLISH_MONTHS[month - 1] || ''
}

/**
 * Format a Thai 13-digit national ID with dashes.
 * Example: "1234567890123" -> "1-2345-67890-12-3"
 */
export function formatNationalId(id: string): string {
  const digits = id.replace(/\D/g, '')
  if (digits.length !== 13) return id
  return `${digits[0]}-${digits.slice(1, 5)}-${digits.slice(5, 10)}-${digits.slice(10, 12)}-${digits[12]}`
}

/**
 * Format a year and month as a bilingual period string.
 * Example: (2026, 3) -> "มีนาคม 2026 / March 2026"
 */
export function formatPeriod(year: number, month: number): string {
  return `${formatMonthEn(month)} ${year}`
}
